import { render, staticRenderFns } from "./QcShopkeeper.vue?vue&type=template&id=2d36f95a&scoped=true"
import script from "./QcShopkeeper.vue?vue&type=script&lang=js"
export * from "./QcShopkeeper.vue?vue&type=script&lang=js"
import style0 from "./QcShopkeeper.vue?vue&type=style&index=0&id=2d36f95a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36f95a",
  null
  
)

export default component.exports